import React from 'react';

import { Button, Stack, Text } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { ModalTitle } from 'components/modals/ModalTitle';
import cx from 'components/modals/styles.module.scss';

type Props = {
    type: 'loading' | 'saving';
};

const ForceRefreshModal = ({ innerProps }: ContextModalProps<Props>) => (
    <Stack gap="xs" p="sm">
        <ModalTitle>Sorry, something went wrong.</ModalTitle>
        {innerProps.type === 'loading' && (
            <Text className={cx.description} ta="center">
                Seems like this diagram is corrupted. We have sent this incident to our team.
                <br />
                If this problem persists, please use the Feedback button to let us know.
            </Text>
        )}
        {innerProps.type === 'saving' && (
            <Text className={cx.description} ta="center">
                Something went wrong while trying to save your project.
                <br />
                Please reload your page.
            </Text>
        )}
        <Button
            fullWidth
            variant="gradient"
            onClick={() => {
                window.location.reload();
            }}
        >
            Reload
        </Button>
    </Stack>
);

export { ForceRefreshModal };
